export default [
  {
    altText: "Shop",
    bannerID: "Shop",
    buttonText: "",
    buttonUrl: "https://www.airasia.com/shop/id/id",
    redirectUrl: "https://www.airasia.com/shop/id/id",
    desktopImage:
      "https://images.contentstack.io/v3/assets/blt5baee87c838aa782/blt48191c86e80138c9/63edb4751c653e112744cb85/SEO-landing-pages-aaHero-Banner-D-1270x280-80kb.jpg",
    headline: "",
    mobileImage:
      "https://images.contentstack.io/v3/assets/blt5baee87c838aa782/bltb64f48b9621d5b26/63edb4756e0bd910b9c15bd3/SEO-landing-pages-aaHero-Banner-M-720x200-40kb.jpg",
    subheadline: "",
    tabletImage:
      "https://images.contentstack.io/v3/assets/blt5baee87c838aa782/blt48191c86e80138c9/63edb4751c653e112744cb85/SEO-landing-pages-aaHero-Banner-D-1270x280-80kb.jpg",
  }
]
